import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "flex items-center justify-center w-full" }
const _hoisted_3 = { class: "flex flex-col items-center justify-center gap-3 pt-5 pb-6" }
const _hoisted_4 = {
  key: 0,
  class: "mb-2 text-sm"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Haz clic para subir un archivo", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        for: "dropzone-file",
        onDragenter: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switcActivationDropzone && _ctx.switcActivationDropzone(...args)), ["prevent"])),
        onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switcActivationDropzone && _ctx.switcActivationDropzone(...args)), ["prevent"])),
        onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        onDrop: _cache[4] || (_cache[4] = _withModifiers(event => _ctx.inputFileHandler(event, true), ["prevent"])),
        class: _normalizeClass([{ 'bg-button-green/80 text-white': _ctx.activeDropzone }, "flex flex-col items-center hover:bg-button-green/80 hover:text-primary justify-center w-full border-2 border-dashed rounded-lg cursor-pointer dark:border-gray-600"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_mdicon, {
            name: "file-document-multiple",
            size: "30"
          }),
          (!_ctx.fileName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _createTextVNode(" o arrastra el archivo aquí. ")
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.fileName), 1))
        ]),
        _createElementVNode("input", {
          id: "dropzone-file",
          type: "file",
          class: "hidden",
          accept: ".jpg, .jpeg, .png",
          onChange: _cache[0] || (_cache[0] = event => _ctx.inputFileHandler(event))
        }, null, 32)
      ], 34)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.showAlert)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            message: _ctx.message,
            type: _ctx.type
          }, null, 8, ["message", "type"]))
        : _createCommentVNode("", true)
    ])
  ]))
}